"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SurveyAuthoringSubmitCommand = exports.SurveyAuthoringPreviewCommand = exports.SurveyDuplicateAuthoringCommand = exports.SurveyAuthoringCommand = exports.SurveyAuthoringCommands = void 0;
const Command_1 = require("../../_shared/commands/Command");
var SurveyAuthoringCommands;
(function (SurveyAuthoringCommands) {
    SurveyAuthoringCommands["Start"] = "survey/authoring";
    SurveyAuthoringCommands["Duplicate"] = "survey/authoring/duplicate";
    SurveyAuthoringCommands["Preview"] = "survey/authoring/preview";
    SurveyAuthoringCommands["Submit"] = "survey/authoring/submit";
})(SurveyAuthoringCommands = exports.SurveyAuthoringCommands || (exports.SurveyAuthoringCommands = {}));
function SurveyAuthoringCommand(draftId) {
    const data = {
        command: SurveyAuthoringCommands.Start,
        draftId,
    };
    return new Command_1.Command(data);
}
exports.SurveyAuthoringCommand = SurveyAuthoringCommand;
function SurveyDuplicateAuthoringCommand(surveyId) {
    const data = {
        command: SurveyAuthoringCommands.Duplicate,
        surveyId,
    };
    return new Command_1.Command(data);
}
exports.SurveyDuplicateAuthoringCommand = SurveyDuplicateAuthoringCommand;
function SurveyAuthoringPreviewCommand(draft, trackingFields) {
    const data = {
        draft,
        trackingFields,
        command: SurveyAuthoringCommands.Preview,
    };
    return new Command_1.Command(data);
}
exports.SurveyAuthoringPreviewCommand = SurveyAuthoringPreviewCommand;
function SurveyAuthoringSubmitCommand(draftId) {
    const data = {
        command: SurveyAuthoringCommands.Submit,
        draftId,
    };
    return new Command_1.Command(data);
}
exports.SurveyAuthoringSubmitCommand = SurveyAuthoringSubmitCommand;
//# sourceMappingURL=SurveyAuthoringCommands.js.map